<div class="form-header">
  <p>To enable ConnectWise Manage Integration with Identify, you must first create API credentials.<br>
    Please <a href="https://docs.connectwise.com/ConnectWise_Identify/003/010" target="_blank">see here</a> for instructions on how to do that.</p>  
  <p *ngIf="!sessionService.hasRole(RoleType.ADMIN)  && sessionService.isAccountType('SYSTEM')">
    Your role does not allow for saving settings changes on this screen.
  </p>
</div>
<form [formGroup]="form">
  <div class="formFieldList">
    <mat-form-field>
      <input tabindex="13" matInput formControlName="companySite" placeholder="ConnectWise Manage Site" required>
      <mat-error *ngIf="form.controls.companySite?.errors?.connectionError">Could not connect to your ConnectWise Manage site</mat-error>
      <mat-hint>e.g. https://na.myconnectwise.net</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <input tabindex="14" matInput formControlName="companyId" placeholder="Company Id" required>
      <mat-error *ngIf="form.controls.companyId?.errors?.invalid">Could not find your company Id</mat-error>
      <mat-error *ngIf="form.controls.companyId?.errors?.alreadyExists">An integration with this company already exists</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input tabindex="15" matInput formControlName="apiPublicKey" placeholder="API Public Key" required>
      <mat-error *ngIf="form.controls.apiPublicKey?.errors?.invalid">API Public/Private key is invalid</mat-error>
      <mat-error *ngIf="form.controls.apiPublicKey?.errors?.invalidPermissions">API key does not have sufficient permission</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input tabindex="16" matInput formControlName="apiPrivateKey" placeholder="API Private Key" type="password" [required]="isNewIntegration">
    </mat-form-field>
    <mat-error *ngIf="form.errors?.failedAuth">Failed to authenticate with Manage. Please check your Company Id and API Keys.</mat-error>

    <div class="form-sub-header">
      Once you have visited the Integrated Users and Manage Companies pages, select Enable Manage Integration to turn the integration on.
    </div>
    <div>
      <mat-checkbox tabindex="12" formControlName="enableManage" (change)="onEnableManage()" [disabled]="(disableIntegrationCheckbox && !originallyEnabled) || readOnly">Enable Manage Integration?</mat-checkbox>
      <mat-error *ngIf="disableIntegrationCheckbox">Manage integration cannot be enabled until all companies are matched. Continue through the wizard to do so.</mat-error>
      <div class="warning" *ngIf="!originallyEnabled && form.controls.enableManage.value">Warning: By enabling Manage Integration, you will lose access to the Integrated Users and Manage Companies pages. Make sure you are done with those pages before enabling.</div>
    </div>
  </div>
</form>